import { render, staticRenderFns } from "./pos-ticket-detail.vue?vue&type=template&id=7bd08790&scoped=true&"
import script from "./pos-ticket-detail.vue?vue&type=script&lang=ts&"
export * from "./pos-ticket-detail.vue?vue&type=script&lang=ts&"
import style0 from "./pos-ticket-detail.vue?vue&type=style&index=0&id=7bd08790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd08790",
  null
  
)

export default component.exports